export default function AccesCoffre() {
  const types = [
    {
      title: "Coffre bloc-baie (intégré)",
      desc: "Le coffre est fusionné avec la fenêtre et le tablier. L'accès se fait par dépose des caches latéraux ou par trappe de visite intégrée. Nécessite des outils fins pour ne pas endommager les joints de la baie.",
    },
    {
      title: "Coffre extérieur sur linteau",
      desc: "Fixé au-dessus de la fenêtre, sur le mur ou dans le linteau. L'accès est direct par le dessous ou les côtés. Risque de détérioration des fixations murales en cas de mauvais calage initial.",
    },
    {
      title: "Coffre intégré dans la maçonnerie",
      desc: "Encastré dans le mur au moment de la construction. L'accès est limité : souvent seule une petite trappe de visite est prévue. En cas de réparation majeure, un démontage partiel de l'habillage peut être nécessaire.",
    },
  ];

  const verifications = [
    "Identification du type de coffre (bloc-baie, extérieur, intégré) avant tout démontage",
    "Repérage des points de fixation et des caches de finition pour un démontage sans casse",
    "Protection du tablier et des coulisses pendant l'intervention pour éviter les rayures",
    "Dépose des joints d'étanchéité avec précaution si le coffre est accessible par le haut",
    "Accès au mécanisme interne par trappe de visite ou démontage des caches latéraux adaptés",
    "Remontage avec réétanchéification et calage des fixations pour éviter les vibrations",
  ];

  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-6">
          Accès au coffre (bloc-baie, extérieur, intégré)
        </h2>
        <p className="text-brand-text leading-relaxed mb-4">
          L'accès au coffre d'un volet roulant varie considérablement selon le type de pose. Un coffre bloc-baie est intégré à la menuiserie de la fenêtre et ne se démonte pas de la même façon qu'un coffre extérieur posé sur un linteau. Un coffre intégré dans la maçonnerie est le plus difficile d'accès, car il est encastré dans le béton ou la brique. Chaque configuration demande une méthode d'intervention spécifique et des outils adaptés.
        </p>
        <p className="text-brand-text leading-relaxed mb-8">
          Nos techniciens interviennent sur tous les types de coffres à Strasbourg et dans le Bas-Rhin. Nous déterminons d'abord le mode d'accès le plus adapté : par trappe de visite, par dépose des caches latéraux, par démontage partiel du coffre, ou par accès direct si le caisson est extérieur. Notre objectif est de réparer le coffre sans dégrader la façade, la fenêtre, ou les finitions intérieures.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-8">
          {types.map((t, i) => (
            <div key={i} className="bg-white rounded-xl border border-brand-border p-5">
              <h3 className="font-semibold text-brand-blue mb-2 text-sm md:text-base">{t.title}</h3>
              <p className="text-sm text-brand-text leading-relaxed">{t.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-xl border border-brand-border p-6 md:p-8">
          <h3 className="text-lg font-semibold text-brand-blue mb-6 flex items-center gap-2">
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-brand-cyan/10 text-brand-cyan">
              <i className="ri-list-check-2"></i>
            </span>
            Étapes d'accès sécurisé au coffre
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {verifications.map((v, i) => (
              <div key={i} className="flex items-start gap-3 bg-brand-light rounded-lg p-4">
                <i className="ri-check-line text-brand-cyan mt-0.5 shrink-0"></i>
                <p className="text-sm text-brand-text leading-relaxed">{v}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}